import MobileChecker from 'mlmi-library/modules/mobile/v1/mobile'

/*
*	Menu
*/

$.fn.SubMenu = function(menu) {
	let submenu = this
	submenu.expanded = false
	submenu.expand_btn = submenu.find('.primary-nav__expand-btn')
	submenu.item = submenu.find('.primary-nav__sub-item')

	submenu.open = function() {
		submenu.expanded = true
		submenu.expand_btn.text('-')
		submenu.item.slideDown(300)
	}

	submenu.close = function() {
		submenu.expanded = false
		submenu.expand_btn.text('+')
		submenu.item.slideUp(300)
	}

	submenu.reset = function() {
		submenu.expanded = false
		submenu.expand_btn.text('+')
		submenu.item.css({
			display: '',
			height: '',
		})
	}

	submenu.clicked = function(e) {
		e.preventDefault()
		e.stopPropagation()
		if (submenu.expanded) {
			submenu.close()
		} else {
			menu.select(submenu)
		}
	}

	return function() {
		submenu.expand_btn.on('click', submenu.clicked)
		return submenu
	}()
}

$.fn.Menu = function() {
	let menu = this
	menu.mobileChecker = new MobileChecker()
	menu.submenus = []

	menu.select = function(_submenu) {
		menu.submenus.forEach(function(submenu) {
			if (submenu == _submenu) {
				submenu.open()
			} else {
				submenu.close()
			}
		})
	}

	menu.toggleMobile = function() {
		menu.submenus.forEach(function(submenu) {
			submenu.reset()
		})
	}

	menu.toggleDesktop = function() {
		//
	}

	return function() {
		menu.mobileChecker.addCallbacks(menu.toggleMobile, menu.toggleDesktop)
		menu.find('.primary-nav__item--parent').each(function() {
			let submenu = $(this).SubMenu(menu)
			menu.submenus.push(submenu)
		})
		return menu
	}()
}

export default {
	menus: [],

	init() {
		const self = this
		$('.menu').each(function() {
			let menu = $(this).Menu()
			self.menus.push(menu)
		})
		$('.header-search__button').on('click', function() {
			if ($('.header__search').hasClass('header__search--visible')) {
				$('.header__search').removeClass('header__search--visible')
			} else {
				$('.header__search').addClass('header__search--visible')
				setTimeout(function() {
					$('.search-form__field').focus()
				}, 200)
			}
		})
		$('.search-form__close-btn').on('click', function() {
			$('.search').removeClass('header__search--visible')
		})
		$('.search-form__field').on('keyup', function(e) {
			const key = e.keyCode || e.which
			if (key == 27) {
				e.preventDefault()
				$('.header__search').removeClass('header__search--visible')
			}
		})
		return self
	},
}
